import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Posts from "../views/Posts.vue";
import Museum from "../views/Museum.vue";
import Studio from "../views/Studio.vue";
import ArtistView from "../views/ArtistView.vue";
import CV from "../views/CV.vue";
import Post from "../views/Post.vue";
import Home from "../views/Home.vue";
import Artists from "../views/Artists.vue";
import Scales from "../views/Scales.vue";
import P5 from "../views/works/P5.vue";
import ArticleIntroduction from "../views/articles/00-Introduction.vue";
import ArticleColorScalesIntro from "../views/articles/01-ColorScalesIntro.vue";
import ArticleIntervals from "../views/articles/11-Intervals.vue";
import ArticleColorSpaces from "../views/articles/12-ColorSpaces.vue";
import ArticleTheColorScale from "../views/articles/13-ColorScale.vue";
import ArticleInstrumentIntro from "../views/articles/20-InstrumentIntro.vue";
import ArticleControls from "../views/articles/21-controls.vue";
import ArticleADSR from "../views/articles/22-ADSR.vue";
import ArticleDisplay from "../views/articles/23-Display.vue";
import Halo from "../views/works/Halo.vue";
import ColorConversion from "../views/ColorConversion.vue";
import HLColorSpace from "../views/HLColorSpace.vue";
import Contact from "../views/Contact.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "/", name: "Home", component: Home, },
  { path: "/color-scales/history", name: "History", component: Museum },
  { path: "/color-scales/studio", name: "Studio", component: Studio },
  { path: "/color-scales/artist/:id", name: "Artist", component: ArtistView },
  { path: "/color-scales/scales", name: "Scales", component: Scales },
  { path: "/color-scales/artists", name: "Artists", component: Artists },
  { path: "/post/:id", name: "Post", component: Post },
  { path: "/CV", name: "CV", component: CV },
  { path: "/projects", name: "Projects", component: Posts },
  { path: "/p5", name: "P5", component: P5 },
  { path: "/color-music/00-introduction", name: "ArticleIntroduction", component: ArticleIntroduction },
  { path: "/color-music/10-color-scales-introduction", name: "ArticleColorScalesIntro", component: ArticleColorScalesIntro },
  { path: "/color-music/11-intervals", name: "ArticleIntervals", component: ArticleIntervals },
  { path: "/color-music/12-color-spaces", name: "ArticleColorSpaces", component: ArticleColorSpaces },
  { path: "/color-music/13-the-color-scale", name: "ArticleTheColorScale", component: ArticleTheColorScale },
  { path: "/color-music/20-instrument-development", name: "ArticleInstrumentIntro", component: ArticleInstrumentIntro },
  { path: "/color-music/21-controls", name: "ArticleControls", component: ArticleControls },
  { path: "/color-music/22-adsr", name: "ArticleADSR", component: ArticleADSR },
  { path: "/color-music/23-display", name: "ArticleDisplay", component: ArticleDisplay },
  { path: "/halo", name: "Halo", component: Halo },
  { path: "/color-conversion", name: "ColorConversion", component: ColorConversion },
  { path: "/HL-color-space", name: "HLColorSpace", component: HLColorSpace },
  { path: "/contact", name: "Contact", component: Contact },
  { path: "/artworks", beforeEnter() { location.href = 'https://paurosello.net/gallery' } },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

export default router;
